<template>
  <div class="contents7">
    <img class="bg" :src="bgImg" />
    <div class="contents">
      <p class="text1">
        누적 100,000건<br />
        카수리 100% 리얼 후기!
      </p>
      <p class="text2">
        카수리 이용자들이 직접 쓴 후기와 평점.<br />
        평균 고객만족도 4.9/5
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bgImg: 'static/img/main-content/contents7.png',
      isMobile: false
    }
  },
  mounted() {
    window.addEventListener('resize', this.resize)
    this.resize()
  },
  methods: {
    resize() {
      if (window.innerWidth > 640) {
        this.bgImg = 'static/img/main-content/contents7.png'
        this.isMobile = false
      } else {
        this.bgImg = 'static/img/mobile/main-content/contents7.png'
        this.isMobile = true
      }
    }
  }
}
</script>

<style scoped>
.contents7 {
  width: 100%;
  position: relative;
}
.contents7 .bg {
  width: 100%;
  height: auto;
  display: block;
}
/* pc */
@media (max-width: 1280px) {
  .text1 {
    font-style: normal;
    font-weight: 300;
    font-size: 38px;
    line-height: 42px;
    color: #000000;
    margin-bottom: 5%;
  }
  .text2 {
    font-style: normal;
    font-weight: 300;
    font-size: 15px;
    line-height: 23px;
    color: #444444;
  }
}
@media (min-width: 1280px) {
  .text1 {
    font-style: normal;
    font-weight: 300;
    font-size: 3vw;
    line-height: 3.7vw;
    color: #000000;
    margin-bottom: 5%;
  }
  .text2 {
    font-style: normal;
    font-weight: 300;
    font-size: 1.2vw;
    line-height: 1.8vw;
    color: #444444;
  }
}
@media (min-width: 641px) {
  .contents7 .contents {
    position: absolute;
    top: 0;
    left: 0;
    width: 50%;
    height: 100%;
    padding: 15% 0 0 15%;
  }
}
/* mobile */
@media (max-width: 640px) {
  .contents7 .contents {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    text-align: center;
  }
  .text1 {
    margin-top: 20%;

    font-style: normal;
    font-weight: 300;
    font-size: 6.4vw;
    line-height: 10vw;
    color: #000000;
    margin-bottom: 5%;
  }
  .text2 {
    font-style: normal;
    font-weight: 300;
    font-size: 4vw;
    line-height: 6vw;
    color: #444444;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contents/main/Contents7.vue